'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('vehicle_parking', {
      url: '/account/parking/vehicle_parking?jurisdiction&sta_recid&policyName',
      template: '<vehicle-parking></vehicle-parking>',
      authenticate: true,
      params: {
        jurisdiction: null,
        sta_recid: null,
        policyName: null
      }
    });
}



// WEBPACK FOOTER //
// ./client/app/account/parking/vehicle_parking/vehicle_parking.routes.js